import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FfsBannerComponent } from './ffs-banner.component';
import { PrimeNGModule } from '../prime-ng.module';
import { ConvertHtmlPipe } from '../pipes/convert-html.pipe';

@NgModule({
    declarations: [
        FfsBannerComponent,
        ConvertHtmlPipe
    ],
    imports: [
        CommonModule,
        PrimeNGModule
    ],
    exports: [
        FfsBannerComponent,
        ConvertHtmlPipe
    ]
})
export class FfsBannerModule { }